import React, { Suspense, useContext } from "react";
import { AuthContext } from './AuthProvider';
import FlexCenterCenter from "nood-comp/src/comp/ui/containers/FlexCenterCenter";
import SpinnerApple from "nood-comp/src/comp/ui/spinner/Spinner.Apple";
import AdminLoginPage from "src/routes/admin-login/AdminLoginPage";
export default function AuthenticatedPage(_ref) {
  var children = _ref.children;
  var auth = useContext(AuthContext);
  if (auth.user === void 0) return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, {
    size: 24,
    strokeSize: 1.5
  }));
  if (auth.user === null) return /*#__PURE__*/React.createElement(AdminLoginPage, null);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, {
      size: 25,
      strokeSize: 1.5
    })))
  }, children);
}